import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import FooterBar from './FooterBar'
import LevelSettingsFormHandler from './_form/LevelSettingsFormHandler'
import LevelsSettings from './LevelsSettings'
import ControlledModal from '../../../components/modals/ControlledModal'
import Separator from '../../../components/helpers/Separator'
import LevelsLoader from './_load/LevelsLoader'

const LevelsSettingsModal = props => {
  const { t } = useTranslation('levelsSettings')

  return (
    <ControlledModal {...props}>
      <LevelsLoader>
        <Title size="h4" align="center">
          {t('title')}
        </Title>
        <Separator weight={4} />
        <LevelSettingsFormHandler>
          <LevelsSettings />
          <FooterBar />
        </LevelSettingsFormHandler>
      </LevelsLoader>
    </ControlledModal>
  )
}

export default LevelsSettingsModal
